import React from 'react';
import {withRouter} from "react-router-dom";
import MultipleChoices from "../common/MultipleChoices";

const DropdownList = (props) => {
  return <MultipleChoices {...props} />
}

export default withRouter(DropdownList);
